import { useQuery } from '@apollo/client';
import { StaffLandingPageStaffRoleFieldsFragment, StaffLandingPageStaffUserCurrentDocument } from '../../generated';
import { useOid } from '../../hooks/useOid';
import { ComponentQueryLoader } from './component-query-loader';
import { LandingPage } from './landing-page';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from './utils/queryOptions';

export const LandingPageContainer: React.FC = () => {
  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);
  const { data, loading, error } = useQuery(StaffLandingPageStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  return (
    <ComponentQueryLoader
      loading={loading}
      error={error}
      hasData={data?.staffUserCurrent?.role}
      hasDataComponent={<LandingPage roleData={data?.staffUserCurrent?.role as StaffLandingPageStaffRoleFieldsFragment} />}
    />
  );
};
